import { render, staticRenderFns } from "./GerbangTolAdd.vue?vue&type=template&id=5d9f1f80&scoped=true"
import script from "./GerbangTolAdd.vue?vue&type=script&lang=js"
export * from "./GerbangTolAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9f1f80",
  null
  
)

export default component.exports